import styled from 'styled-components';
import { space, borderRadius, fontSize } from '@ifixit/primitives';
import LanguageDropdown from 'Shared/Header/components/dropdowns/language_dropdown';
import { createTrackedRoot } from 'Shared/react-mount-tracker';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

const LanguageDropdownWrapper = styled(LanguageDropdown)`
   position: absolute;
   right: -${space[4]};
   margin-top: ${space[3]};
   font-size: ${fontSize.md};
   border-radius: ${borderRadius.lg};

   opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
   visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
   transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-1.5rem)')};
   transition:
      opacity 0.2s linear,
      transform 0.2s ease-in-out,
      visibility 0.2s linear;
`;

class LanguageDropdownButton {
   constructor() {}

   setProps = props => (this.props = props);

   setRenderTarget = element => (this.renderTarget = element);

   toggle = event => {
      trackAnalyticsCustomEvent({
         eventCategory: 'Language',
         eventAction: 'Language Dropdown - Click',
      });

      this.isOpen = !this.isOpen;

      if (this.isOpen) {
         this.showDropdown(event);
      } else {
         this.hideDropdown(event, true);
      }
   };

   showDropdown = event => {
      event.preventDefault();
      // Without this, the same click bubbles to the document listener added
      // below and immediately closes the dropdown.
      event.stopPropagation();
      this.renderTarget.classList.remove('fade-hidden');
      document.addEventListener('click', this.hideDropdown);
      this.renderDropdown();
   };

   hideDropdown = (event, force = false) => {
      if (force || !this.renderTarget.contains(event.target)) {
         this.isOpen = false;
         this.renderDropdown();
         document.removeEventListener('click', this.hideDropdown);
         setTimeout(() => this.renderTarget.classList.add('fade-hidden'), 150);
      }
   };

   renderDropdown = () => {
      const { languages, translationPreferencesUrl } = this.props;

      const root = createTrackedRoot(this.renderTarget);
      root.render(
         <LanguageDropdownWrapper
            isOpen={this.isOpen}
            languages={languages}
            translationPreferencesUrl={translationPreferencesUrl}
         />
      );
   };
   isOpen = false;
   props = null;
   renderTarget = null;
}

window.languageDropdownButton = new LanguageDropdownButton();
